import styled from "styled-components";
import { darken, tint } from "polished";
import { device } from "../../styles/device";

const base = (props) => props.theme.colors.primary;

export const ContainerCard = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 174.5px;
    min-width: 174.5px;
    border: 1.5px solid transparent;

    position: relative;
    box-sizing: border-box;
    background: ${props => props.theme.colors.white};
    color: rgb(105, 105, 105);
    border-radius: 16px;
    padding: 14px;
    transition: border-color 200ms ease, box-shadow 200ms ease, transform 200ms ease;

    &:hover {
      border-color: ${props => tint(0.9, base(props))};
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.09);
      transform: translateY(-4px);
    }

    &:hover h3 {
      color: ${props => base(props)};
    }

    @media ${device.laptop} {
        width: 270px;
        min-width: 270px;
    }

    @media (max-width: 602px){
      width:calc(50% - 8px);
      min-width:calc(50% - 8px);
    }
`;

export const ContainerDatails = styled.div`
    width: 100%;
    height: 45px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    border-radius: 0px 0px 12px 12px;
    justify-content: center;
    align-items: center;
    display: none;

    span{
        font-size: 14px;
        @media ${device.laptop} {
            font-size: 16px;
        }
        font-weight: 700;
    }

    &.zero-stock{
        display: flex;
        background-color: ${props => props.theme.colors.warning};

        span{
            color: ${props => props.theme.colors.black};
        }
    }

    /* Selo em uma linha: texto curto e preço lado a lado, sem quebrar palavra a palavra. */
    &.promo-pague-mais-leve-menos{
        display: flex;
        justify-content: center;
        gap: 4px;
        padding: 0 4px;
        white-space: nowrap;
        overflow: hidden;
        /* Desconto em verde, como o selo "% OFF": vermelho fica para erro. */
        background-color: ${props => props.theme.colors.promotion};

        & span,
        & span::before{
            font-weight: 500;
            color: ${props => props.theme.colors.white};
            font-size: 11px;
        }

        & span strong{
            font-weight: 700;
            font-size: 12px;
        }

        @media ${device.laptop} {
            & span,
            & span::before{
                font-size: 14px;
            }

            & span strong{
                font-size: 18px;
            }
        }
    }
`;

export const ContainerImage = styled.div`
    cursor: pointer;
    position: relative;
    width: 100%;
    aspect-ratio: 4 / 5;
    flex-shrink: 0;
    border-radius: 12px;
    margin-bottom: 16px;
    background: #F5F6FA;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    transition: background-color 200ms ease;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    &:hover {
        background: ${props => tint(0.9, base(props))};
    }
    &:hover ${ContainerDatails} {
        .item-sale {
            display: flex;
            background-color: ${props => base(props)};

            span{
                color: ${props => props.theme.colors.white};
            }
        }
    }
`;

export const ContainerPromo = styled.div`
    background-color: #00bf63;
    border-radius: 999px;
    padding: 2px 8px;
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    span{
        font-size: 11px;
        font-weight: 700;
        color: ${props => props.theme.colors.white};
    }
`;


export const ContainerDatailsPromo = styled.div`
    display: flex;
`;

export const ContainerDetailsPromoName = styled.div`
    display: inline-flex;
    flex-shrink: 0;
`;

export const ContainerDetailsPromoPrice = styled.div`
    align-self: center;
    flex-shrink: 0;
`;

export const ContainerInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;

    h3{
        font-family: 'DM Sans', system-ui, sans-serif;
        color: ${props => props.theme.colors.neutral900};
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        min-height: 34px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: color 200ms ease;
    }

    .old-price{
        color: ${props => props.theme.colors.neutral600};
        font-size: 11px;
        font-weight: 500;
        text-decoration: line-through;
    }

    .price{
        color: ${props => props.theme.colors.neutral900};
        font-family: 'Sora', system-ui, sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
    }

    /* Preço no Pix (P-113) */
    .pix-label{
        font-family: 'DM Sans', system-ui, sans-serif;
        font-size: 12px;
        font-weight: 600;
        color: ${props => props.theme.colors.success};
    }

    .other-price{
        color: ${props => props.theme.colors.neutral600};
        font-size: 12px;
        font-weight: 500;
    }

    .pix-hint{
        margin-top: 4px;
    }
`;

export const ContainerRating = styled.div`
    display: flex;
    flex-direction: row;
`;

export const ContainerPriceAndAddCart = styled.div`
    width: 100%;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const ContainerPrice = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;

export const ContainerCartOrRemember = styled.div`
    width: 100%;
    margin-top: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 6px;
    background: ${props => base(props)};
    border-radius: 999px;
    padding: 10px 0;
    transition: background-color 200ms ease;

    &:hover {
        background: ${props => darken(0.08, base(props))};
    }

    svg {
        width: 16px;
        height: 16px;
        fill: ${props => props.theme.colors.white};
    }

    span{
        color: ${props => props.theme.colors.white};
        font-size: 13px;
        font-weight: 700;
    }
`;
export const ContainerManufacturer = styled.div`
    align-self: flex-start;
    width: 100%;
    border-radius: 8px;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 4px;

    span {
      color: gray;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
`;
